import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '../index.css'
import { GuestApp } from '../visio-guest/GuestApp'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GuestApp />
  </StrictMode>,
)
